import {
  CYCLOPS_ORGANIZATIONS_DATA_LOADED,
  CYCLOPS_ORGANIZATIONS_DATA_CLEAR,
  CYCLOPS_LIVESTREAMS_DATA_LOADED,
  CYCLOPS_LIVESTREAMS_DATA_CLEAR,
  CYCLOPS_LIVESTREAM_DETAILS_LOADED,
  CYCLOPS_LIVESTREAM_DETAILS_CLEAR,
  CYCLOPS_PIRACY_STREAMS_LOADED,
  CYCLOPS_PIRACY_STREAMS_CLEAR,
  CYCLOPS_ANALYTICS_DATA_LOADED,
  CYCLOPS_ANALYTICS_DATA_CLEAR,
  CYCLOPS_CDN_CONSTANTS_LOADED,
  CYCLOPS_CDN_CONSTANTS_CLEAR,
  CYCLOPS_CONSTANTS_CONFIG_LOADED,
  CYCLOPS_CONSTANTS_CONFIG_CLEAR,
  CYCLOPS_WATERMARKS_LOADED,
  CYCLOPS_WATERMARKS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  organizationLivestreams: null,
  livestreamDetails: null,
  piracyStreams: null,
  analyticsData: null,
  cdnConstants: null,
  companyOrganizations: null,
  watermarkOptions: null,
  constantsConfig: null,
};

const cyclops = (state = initialState, action) => {
  switch (action.type) {
    case CYCLOPS_ORGANIZATIONS_DATA_LOADED:
      return {
        ...state,
        companyOrganizations: action.payload.companyOrganizations,
      };

    case CYCLOPS_ORGANIZATIONS_DATA_CLEAR:
      return {
        ...state,
        companyOrganizations: null,
      };

    case CYCLOPS_LIVESTREAMS_DATA_LOADED:
      return {
        ...state,
        organizationLivestreams: action.payload.livestreams,
      };

    case CYCLOPS_LIVESTREAMS_DATA_CLEAR:
      return {
        ...state,
        organizationLivestreams: null,
      };

    case CYCLOPS_LIVESTREAM_DETAILS_LOADED:
      return {
        ...state,
        livestreamDetails: action.payload.livestreamDetails,
      };

    case CYCLOPS_LIVESTREAM_DETAILS_CLEAR:
      return {
        ...state,
        livestreamDetails: null,
      };

    case CYCLOPS_PIRACY_STREAMS_LOADED:
      return {
        ...state,
        piracyStreams: action.payload.piracyStreams,
      };

    case CYCLOPS_PIRACY_STREAMS_CLEAR:
      return {
        ...state,
        piracyStreams: null,
      };

    case CYCLOPS_ANALYTICS_DATA_LOADED:
      return {
        ...state,
        analyticsData: action.payload.analyticsData,
      };

    case CYCLOPS_ANALYTICS_DATA_CLEAR:
      return {
        ...state,
        analyticsData: null,
      };

    case CYCLOPS_CDN_CONSTANTS_LOADED:
      return {
        ...state,
        cdnConstants: action.payload.cdnConstants,
      };

    case CYCLOPS_CDN_CONSTANTS_CLEAR:
      return {
        ...state,
        cdnConstants: null,
      };

    case CYCLOPS_WATERMARKS_LOADED:
      return {
        ...state,
        watermarkOptions: action.payload.watermarks,
      };

    case CYCLOPS_WATERMARKS_CLEAR:
      return {
        ...state,
        watermarkOptions: null,
      };

    case CYCLOPS_CONSTANTS_CONFIG_LOADED:
      return {
        ...state,
        constantsConfig: action.payload.constantsConfig,
      };

    case CYCLOPS_CONSTANTS_CONFIG_CLEAR:
      return {
        ...state,
        constantsConfig: null,
      };

    default:
      return state;
  }
};

export default cyclops;
